export default "__VITE_ASSET__6896c493__"